/* Greco home sections: reveal-on-scroll and product rail buttons */
(function () {
  'use strict';
  function setup(scope) {
    var roots = scope.querySelectorAll ? scope.querySelectorAll('.gh') : [];
    if (scope.classList && scope.classList.contains('gh')) roots = [scope];
    [].forEach.call(roots, function (root) {
      if (root.__ghInit) return; root.__ghInit = true;
      var items = root.querySelectorAll('[data-reveal]');
      if (items.length && 'IntersectionObserver' in window && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        root.classList.add('js-reveal');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px' });
        [].forEach.call(items, function (el, i) { el.style.transitionDelay = (Math.min(i, 6) * 60) + 'ms'; io.observe(el); });
      }
      if (root.hasAttribute('data-sizes')) {
        var btns = [].slice.call(root.querySelectorAll('[data-size]'));
        var link = root.querySelector('[data-size-link]'), lab = root.querySelector('[data-size-label]');
        var pick = function (btn) {
          var i = btn.dataset.size;
          btns.forEach(function (b) { var on = b === btn; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          [].forEach.call(root.querySelectorAll('[data-rect],[data-text]'), function (el) {
            var on = (el.dataset.rect || el.dataset.text) === i;
            el.classList.toggle('is-on', on);
          });
          var t = root.querySelector('[data-text="' + i + '"]'); if (t) t.parentNode.appendChild(t);
          if (link) link.href = btn.dataset.href;
          if (lab) lab.textContent = btn.dataset.label;
        };
        btns.forEach(function (b) {
          b.addEventListener('click', function () { pick(b); });
          b.addEventListener('mouseenter', function () { pick(b); });
          b.addEventListener('focus', function () { pick(b); });
        });
      }
      var track = root.querySelector('.gh-rail__track');
      if (track) {
        [].forEach.call(root.querySelectorAll('[data-rail]'), function (btn) {
          btn.addEventListener('click', function () {
            var card = track.querySelector('.gh-card');
            var step = card ? card.getBoundingClientRect().width + 18 : 300;
            track.scrollBy({ left: (+btn.dataset.rail) * step * 2, behavior: 'smooth' });
          });
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(document); }); else setup(document);
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
